var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 74 74"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play_circle_svg__a",
    width: 74,
    height: 74,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.018.488h73.24v72.913H.018z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play_circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.534 47.806 17.013-10.861-17.013-10.861v21.722Zm6.103 16.481c-3.815 0-7.387-.72-10.718-2.163-3.332-1.444-6.231-3.394-8.697-5.85-2.468-2.456-4.427-5.342-5.877-8.66-1.449-3.315-2.173-6.871-2.173-10.669s.724-7.355 2.173-10.673c1.45-3.315 3.41-6.201 5.877-8.658 2.466-2.455 5.365-4.404 8.697-5.849 3.33-1.442 6.903-2.163 10.718-2.163 3.815 0 7.388.721 10.72 2.163 3.331 1.445 6.23 3.394 8.698 5.849 2.466 2.457 4.424 5.343 5.874 8.658 1.449 3.318 2.173 6.875 2.173 10.673 0 3.797-.724 7.354-2.173 10.67-1.45 3.317-3.408 6.203-5.874 8.658-2.468 2.457-5.367 4.407-8.697 5.851-3.333 1.442-6.906 2.163-10.721 2.163Zm0-3.038c6.816 0 12.588-2.354 17.318-7.063 4.73-4.709 7.096-10.456 7.096-17.241s-2.366-12.532-7.096-17.241-10.502-7.064-17.318-7.064c-6.815 0-12.588 2.355-17.318 7.064-4.73 4.709-7.095 10.456-7.095 17.241s2.365 12.532 7.095 17.241c4.73 4.709 10.503 7.063 17.318 7.063Z"
  }))));
};
export default SvgPlayCircle;